import type { OrderCustomerOrderDto } from "@/api/dtos";
import type { CustomerOrder } from "@/api/order/_models/Order";
import { toExternalStatusFromOrderExternalStatusDto } from "./toExternalStatusFromOrderExternalStatusDto";

/** DTO → domain for the retailer order above a sale. */
export const toCustomerOrderFromOrderCustomerOrderDto = (
  dto: OrderCustomerOrderDto,
): CustomerOrder => {
  const externalStatuses = (dto.externalStatuses ?? []).map((x) =>
    toExternalStatusFromOrderExternalStatusDto(x),
  );

  return {
    id: dto.id,
    reference: dto.reference,
    customerId: dto.customerId,
    customerName: dto.customerName ?? undefined,
    customerTags: dto.customerTags ?? [],
    externalStatuses,
  };
};
